import { connect } from 'react-redux'

import { fetchPurchasedGifts, fetchMonetizeGift, giftTypes } from '../shop/shopActions'
import Gifts from './Gifts'

const mapStateToProps = state => ({
  gifts: state.shop.gifts,
  boughtGifts: (state.shop.gifts !== undefined)
    ? state.shop.gifts.filter((item) => (item.giftType === giftTypes.bought))
    : [],
  receivedGifts: (state.shop.gifts !== undefined)
    ? state.shop.gifts.filter((item) => (item.giftType === giftTypes.received))
    : [],
  isLoading: state.shop.isLoading,
  personId: state.authorization.personId
})

const mapDispatchToProps = dispatch => ({
  fetchGifts: personId => dispatch(fetchPurchasedGifts(personId)),
  monetizeGift: (personId, giftId) => dispatch(fetchMonetizeGift(personId, giftId))
})

const mergeProps = (stateProps, dispatchProps) => ({
  gifts: stateProps.gifts,
  isLoading: stateProps.isLoading,
  boughtGifts: stateProps.boughtGifts,
  receivedGifts: stateProps.receivedGifts,
  fetchGifts: () => dispatchProps.fetchGifts(stateProps.personId),
  monetizeGift: giftId => dispatchProps.monetizeGift(stateProps.personId, giftId)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Gifts)
